import { render } from "./UpdateTrainingForm.vue?vue&type=template&id=5429b424&scoped=true"
import script from "./UpdateTrainingForm.vue?vue&type=script&lang=js"
export * from "./UpdateTrainingForm.vue?vue&type=script&lang=js"

import "./UpdateTrainingForm.vue?vue&type=style&index=0&id=5429b424&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5429b424"]])

export default __exports__